import axios from 'axios';
import {
  GET_FEEDBACK,
  ERROR_GET_FEEDBACK,
  GET_FEEDBACK_STATUS_RATIO,
  ERROR_GET_FEEDBACK_STATUS_RATIO,
} from '../types';

export const getFeedbacks = (apiUrl) => async (dispatch) => {
  try {
    const res = await axios.get(apiUrl);
    dispatch({
      type: GET_FEEDBACK,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: ERROR_GET_FEEDBACK,
      payload: error,
    });
  }
};
export const getFeedbackStatusRatio = (apiUrl) => async (dispatch) => {
  try {
    const res = await axios.get(apiUrl);
    dispatch({
      type: GET_FEEDBACK_STATUS_RATIO,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: ERROR_GET_FEEDBACK_STATUS_RATIO,
      payload: error,
    });
  }
};
